import React from 'react'
import PropTypes from 'prop-types'
import { ContractVehicleShape, ContractVehiclesShape } from './prop_shapes/PropShapes'

const ContractVehicleDropdown = ({ contractVehicles, selectedContractVehicle, handleAddContractVehicleClick, handleUnselectContractVehicle }) => {
  const handleNaspoCase = (list) => {
    const naspoIndex = list.findIndex(cv => cv.name === 'NASPO ValuePoint')
    if (naspoIndex >= 0) {
      const [naspoCv] = list.splice(naspoIndex, 1)
      list.unshift(naspoCv)
    }
    return list
  }

  const placeholderText = 'Select a Contract Vehicle'

  const contractVehiclesList = () => {
    const list = handleNaspoCase([...contractVehicles])
    const elementsList = list.map(cv =>
      <li key={cv.id} onClick={() => handleAddContractVehicleClick(cv)}>{cv.name}</li>
    )
    const unselectOption = <li key={0} onClick={() => handleUnselectContractVehicle()}>{placeholderText}</li>
    return (
      <ul>
        {unselectOption}
        {elementsList}
      </ul>
    )
  }

  const renderContractVehicleSelect = () => {
    const text = selectedContractVehicle ? selectedContractVehicle.name : placeholderText
    const disabled = contractVehicles.length < 1
    return (
      <div className='select-dropdown-container'>
        <label className='dropdown-label'>Contract Vehicle</label>
        <button type='button' data-toggle='contract-vehicle-dropdown' disabled={disabled} className='dropdown-button'>{text}<i className='fa-solid fa-sort dropdown-icon' /></button>
        <div id='contract-vehicle-dropdown' className='dropdown-pane has-position-bottom select-dropdowns' data-dropdown data-close-on-click>
          {contractVehiclesList()}
        </div>
      </div>
    )
  }

  return renderContractVehicleSelect()
}

ContractVehicleDropdown.propTypes = {
  contractVehicles: ContractVehiclesShape.isRequired,
  selectedContractVehicle: ContractVehicleShape,
  handleAddContractVehicleClick: PropTypes.func.isRequired,
  handleUnselectContractVehicle: PropTypes.func.isRequired
}

ContractVehicleDropdown.defaultProps = {
  contractVehicles: [],
  selectedContractVehicle: null
}

export default ContractVehicleDropdown
